import { useState, useEffect } from 'react'
import classNames              from 'classnames'
import { Button }              from 'antd'

import { Image, Spinner } from 'components'
import { t, adjust, ui }  from 'tools'
import appConfig          from 'config'

import './onboarding.scss'

const lt = ( config, data, key ) => t( `identityOnboarding.${config.translate_prefix || ''}${key}`, data ),

      windowOpener = ( url, cb ) => {
          return () => {
              ( cb ) && ( cb())
              window.open( url )
          }
      },

      comparator = ( key, value, check, straight ) => {
          switch ( key ) {
              case 'os':
                  if ( value[ 0 ] === '!' ) {
                      const
                          os = value.substr( 1 )

                      return straight
                          ? ( os.toLowerCase() !== check.toLowerCase())
                          : ( os.toLowerCase() === check.toLowerCase())

                  } else {
                      return straight
                          ? ( value.toLowerCase() === check.toLowerCase())
                          : ( value.toLowerCase() !== check.toLowerCase())
                  }

              default:
                  return straight
                      ? ( typeof value === 'boolean' ? value !== !check : value === check )
                      : ( typeof value === 'boolean' ? value !== !!check : value !== check )
          }

      },

      NfcStick = ({ user }) => {
          const
              fallback = 'https://server.tabee.mobi/media/company_square_logo/Tabee.png'

          return (
              <div className="onboarding-popup-nfc">
                  <Image
                      resize = { false }
                      fallback = { fallback }
                      src = { user.logo ? `${appConfig.api.url}/media/${user.logo}` : fallback }
                      alt = ""
                  />
              </div>
          )
      },

      Buttons = ({ config, loading, onPrimary, onSecondary, onImage }) => {
          return (
              <div className='onboarding-popup-buttons'>
                  {
                      config.custom_button && (
                          loading
                              ? (
                                      <button type="button" className="ant-btn ant-btn-ghost">
                                          <Spinner />
                                      </button>
                                  )
                              : (
                                      <CustomButton
                                          config = { config }
                                          onClick = { onImage }
                                      />
                                  )
                      )
                  }
                  {
                      config.primary_button && (
                          <Button type="primary" onClick={loading ? null : onPrimary}>
                              {
                                  loading
                                      ? <Spinner />
                                      : lt( config, {}, config.primary_button.text )
                              }
                          </Button>
                      )
                  }
                  {
                      config.secondary_button && (
                          <Button type="ghost" onClick={loading ? null : onSecondary}>
                              { loading ? '' : lt( config, {}, config.secondary_button.text ) }
                          </Button>
                      )
                  }
              </div>
          )
      },

      CustomButton = ({ config, onClick }) => {
          if ( config.custom_button.src ) {
              return (
                  <img
                      src = { config.custom_button.src }
                      alt = {
                          config.text
                              ? lt( config, {}, config.custom_button.text )
                              : ''
                      }

                      onClick = { onClick }
                  />
              )
          }

          return (
              <Button type="custom" onClick={onClick} style={ config.custom_button.style || {}}>
                  { config.custom_button.icon && (
                      <img
                          src = { config.custom_button.icon }
                          alt = ""
                      />
                  )}
                  <span style={{ color: config.custom_button.style?.color || 'inherit' }}>
                      { lt( config, {}, config.custom_button.text ) }
                  </span>
              </Button>
          )
      },

      OnboardingTemplateDefault = ({ config, user, image, onFail, onPrimary, onSecondary, onImage }) => {
          return (
              <>
                  <div className='onboarding-popup-wrap'>
                      <div className={classNames( 'onboarding-popup-content', !image && 'no-image' )}>
                          <div className='onboarding-popup-logo'>
                              <svg xmlns="http://www.w3.org/2000/svg" width="66" height="12" fill="none">
                                  <path fill="#1B1B1B" fillRule="evenodd" d="M.424693 3.04732H4.51825V11.649c0 .1934.15649.351.34953.351h2.91207c.19321 0 .34953-.1571.34953-.351V3.04732h3.19102c.1931 0 .4202-.14047.5077-.31375L13.025.363169c.0874-.173178.0021-.3137521-.1908-.3137521H.349229C.156078.0494169 0 .206671 0 .400655V2.69608c0 .19428.156364.35124.34925.35124h.075443ZM43.3402.549079c0-.256528.2079-.4644855.4644-.4644855h8.7359c.2565 0 .4644.2079575.4644.4644865v1.88516c0 .25653-.2079.46448-.4644.46448h-5.8436v1.69433h4.2867c.3458 0 .5703.36421.415.67311l-.9476 1.88515c-.0789.15687-.2395.25587-.415.25587h-3.3391v1.70991h5.8436c.2565 0 .4644.20796.4644.46449v1.88512c0 .2566-.2079.4645-.4644.4645h-8.7359c-.2565 0-.4644-.2079-.4644-.4645V.549079ZM56.7997.0845935c-.2565 0-.4645.2079575-.4645.4644855v.942581h-.002v9.03254h.002v.9425c0 .2566.208.4645.4645.4645h8.7358c.2565 0 .4645-.2079.4645-.4645V9.58158c0-.25653-.208-.46449-.4645-.46449h-5.881V7.40718h3.3765c.1756 0 .3362-.099.415-.25587l.9477-1.88515c.1553-.3089-.0693-.67311-.415-.67311h-4.3242V2.89872h5.881c.2565 0 .4645-.20795.4645-.46448V.54908c0-.256529-.208-.4644865-.4645-.4644865h-8.7358ZM20.692 7.72692h-2.9116l1.4558-2.93034 1.4558 2.93034Zm-4.401 2.99788h5.8904l.4431.8919c.0867.1746.3125.3149.505.3149h2.9378c.1924 0 .2787-.1407.1924-.3143L20.6776.381313c-.0864-.173829-.3124-.3142931-.505-.3142931h-1.8733c-.1924 0-.4181.1404641-.5045.3142931L12.2126 11.6173c-.0862.1736.0001.3143.1924.3143h2.9379c.1925 0 .4182-.1402.5046-.3141l.4435-.8927Zm15.8473-8.13094h3.2239c.565 0 1.0231.45513 1.0231 1.01657 0 .56144-.4581 1.01657-1.0231 1.01657v.0032h-3.2239V2.59386Zm3.4805 4.58639h-3.4805v2.06543h3.4526c.0364.00323.0733.00488.1105.00488.6247 0 1.1311-.46407 1.1311-1.03652 0-.57245-.5064-1.03652-1.1311-1.03652-.0278 0-.0553.00092-.0826.00273Zm4.3761 1.44299c0-1.2582-.6559-2.35314-1.6232-2.91764.746-.57117 1.2306-1.49563 1.2306-2.53889 0-1.6861-1.2659-3.061876-2.8547-3.1374716L32.3894.0083922 29.2472.0003067c-.257-.0006613-.4657.2074893-.4657.4644843V11.4881c0 .2566.208.4645.4645.4645h3.1434l4.6981-.0018c1.6239-.1269 2.9074-1.5675 2.9074-3.32756Z" clipRule="evenodd"/>
                              </svg>
                          </div>
                          {
                              config.content.sublogo && (
                                  <span className="onboarding-popup-subheader">
                                      { lt( config, {}, config.content.sublogo ) }
                                  </span>
                              )
                          }
                          <h3>{ lt( config, user, config.content.header ) }</h3>
                          <p>{ lt( config, user, config.content.text ) }</p>
                      </div>
                      {
                          image && (
                              <div className='onboarding-popup-image'>
                                  <Image
                                      key = { image }
                                      resize = { false }
                                      fallback = { config.images?.default }
                                      src = { image }
                                      alt = ""

                                      onFail = { onFail }
                                  />
                              </div>
                          )
                      }
                  </div>
                  <Buttons config={config} onPrimary={onPrimary} onSecondary={onSecondary} onImage={onImage} />
              </>
          )
      },

      OnboardingTemplateIcons = ({ config, user, onPrimary, onSecondary, onImage }) => {
          return (
              <>
                  <div className='onboarding-popup-wrap'>
                      <div className={classNames( 'onboarding-popup-content' )}>
                          <h3>{ lt( config, user, config.content.header ) }</h3>
                          <ul className='onboarding-popup-icons'>
                              {
                                  ( config.icons || []).map( icon => (
                                      <li key={icon.title} onClick={windowOpener( t( icon.url, user ))}>
                                          <img src={icon.image} alt="" />
                                      </li>
                                  ))
                              }
                          </ul>
                          <p>{ lt( config, user, config.content.text ) }</p>
                      </div>
                  </div>
                  <Buttons config={config} onPrimary={onPrimary} onSecondary={onSecondary} onImage={onImage} />
              </>
          )
      },

      OnboardingTemplateDesign = ({ config, user, designs, design, loading, selectDesign, onPrimary, onSecondary, onImage }) => {
          const
              items = [ appConfig.defaultDesign, ...designs.filter( item => config.designs && config.designs.includes( item.id )) ]

          return (
              <>
                  <div className='onboarding-popup-wrap'>
                      <div className={classNames( 'onboarding-popup-content' )}>
                          <h3>{ lt( config, user, config.content.header ) }</h3>
                          <div className='onboarding-popup-designs-wrap'>
                              <ul className='onboarding-popup-designs' style={{ width: items.length * 64 }}>
                                  {
                                      items.map( item => (
                                          <li
                                              className = { classNames( 'popup-design-item', item.id === design?.id && 'design-item-current' ) }
                                              key = { item.id }
                                              style = {{
                                                  backgroundColor:  item.company_bg_color,
                                                  '--text-color':   item.company_text_color,
                                                  '--custom-color': item.company_custom_text_color
                                              }}

                                              onClick = {() => selectDesign( item ) }
                                          />
                                      ))
                                  }
                              </ul>
                          </div>
                          <p>{ lt( config, user, config.content.text ) }</p>
                      </div>
                  </div>
                  <Buttons config={config} loading={loading} onPrimary={onPrimary} onSecondary={onSecondary} onImage={onImage} />
              </>
          )
      },

      OnboardingTemplateStatic = ({ config, user, image, onFail, onPrimary, onSecondary, onImage }) => {
          return (
              <>
                  <div className='onboarding-popup-wrap'>
                      <div className={classNames( 'onboarding-popup-content', !image && 'no-image' )}>
                          <div className='onboarding-popup-logo'>
                              <svg xmlns="http://www.w3.org/2000/svg" width="66" height="12" fill="none">
                                  <path fill="#1B1B1B" fillRule="evenodd" d="M.424693 3.04732H4.51825V11.649c0 .1934.15649.351.34953.351h2.91207c.19321 0 .34953-.1571.34953-.351V3.04732h3.19102c.1931 0 .4202-.14047.5077-.31375L13.025.363169c.0874-.173178.0021-.3137521-.1908-.3137521H.349229C.156078.0494169 0 .206671 0 .400655V2.69608c0 .19428.156364.35124.34925.35124h.075443ZM43.3402.549079c0-.256528.2079-.4644855.4644-.4644855h8.7359c.2565 0 .4644.2079575.4644.4644865v1.88516c0 .25653-.2079.46448-.4644.46448h-5.8436v1.69433h4.2867c.3458 0 .5703.36421.415.67311l-.9476 1.88515c-.0789.15687-.2395.25587-.415.25587h-3.3391v1.70991h5.8436c.2565 0 .4644.20796.4644.46449v1.88512c0 .2566-.2079.4645-.4644.4645h-8.7359c-.2565 0-.4644-.2079-.4644-.4645V.549079ZM56.7997.0845935c-.2565 0-.4645.2079575-.4645.4644855v.942581h-.002v9.03254h.002v.9425c0 .2566.208.4645.4645.4645h8.7358c.2565 0 .4645-.2079.4645-.4645V9.58158c0-.25653-.208-.46449-.4645-.46449h-5.881V7.40718h3.3765c.1756 0 .3362-.099.415-.25587l.9477-1.88515c.1553-.3089-.0693-.67311-.415-.67311h-4.3242V2.89872h5.881c.2565 0 .4645-.20795.4645-.46448V.54908c0-.256529-.208-.4644865-.4645-.4644865h-8.7358ZM20.692 7.72692h-2.9116l1.4558-2.93034 1.4558 2.93034Zm-4.401 2.99788h5.8904l.4431.8919c.0867.1746.3125.3149.505.3149h2.9378c.1924 0 .2787-.1407.1924-.3143L20.6776.381313c-.0864-.173829-.3124-.3142931-.505-.3142931h-1.8733c-.1924 0-.4181.1404641-.5045.3142931L12.2126 11.6173c-.0862.1736.0001.3143.1924.3143h2.9379c.1925 0 .4182-.1402.5046-.3141l.4435-.8927Zm15.8473-8.13094h3.2239c.565 0 1.0231.45513 1.0231 1.01657 0 .56144-.4581 1.01657-1.0231 1.01657v.0032h-3.2239V2.59386Zm3.4805 4.58639h-3.4805v2.06543h3.4526c.0364.00323.0733.00488.1105.00488.6247 0 1.1311-.46407 1.1311-1.03652 0-.57245-.5064-1.03652-1.1311-1.03652-.0278 0-.0553.00092-.0826.00273Zm4.3761 1.44299c0-1.2582-.6559-2.35314-1.6232-2.91764.746-.57117 1.2306-1.49563 1.2306-2.53889 0-1.6861-1.2659-3.061876-2.8547-3.1374716L32.3894.0083922 29.2472.0003067c-.257-.0006613-.4657.2074893-.4657.4644843V11.4881c0 .2566.208.4645.4645.4645h3.1434l4.6981-.0018c1.6239-.1269 2.9074-1.5675 2.9074-3.32756Z" clipRule="evenodd"/>
                              </svg>
                          </div>
                          {
                              config.content.sublogo && (
                                  <span className="onboarding-popup-subheader">
                                      { lt( config, {}, config.content.sublogo ) }
                                  </span>
                              )
                          }
                          <h3>{ lt( config, user, config.content.header ) }</h3>
                          <p>{ lt( config, user, config.content.text ) }</p>
                      </div>
                      {
                          image && (
                              <div className='onboarding-popup-image'>
                                  <Image
                                      key = { image }
                                      resize = { false }
                                      fallback = { config.images?.default }
                                      src = { image }
                                      alt = ""

                                      onFail = { onFail }
                                  />
                              </div>
                          )
                      }
                      {
                          image && (
                              <NfcStick config={config} user={user} />
                          )
                      }
                  </div>
                  <Buttons config={config} onPrimary={onPrimary} onSecondary={onSecondary} onImage={onImage} />
              </>
          )
      },

      OnboardingTemplateAnim = ({ config, image, user, onFail, onPrimary, onSecondary, onImage }) => {
          return (
              <>
                  <div className='onboarding-popup-wrap'>
                      <div className='onboarding-popup-content'>
                          <h3>{ lt( config, {}, config.content.header ) }</h3>
                          <p>{ lt( config, {}, config.content.text ) }</p>
                      </div>
                      {
                          image && (
                              <div className='onboarding-popup-image'>
                                  <Image
                                      key = { image }
                                      resize = { false }
                                      fallback = { config.images?.default }
                                      src = { image }
                                      alt = ""

                                      onFail = { onFail }
                                  />
                              </div>
                          )
                      }
                      {
                          image && (
                              <NfcStick config={config} user={user} />
                          )
                      }
                  </div>
                  <Buttons config={config} onPrimary={onPrimary} onSecondary={onSecondary} onImage={onImage} />
              </>
          )
      },

      OnboardingCard = ({ visible, loading, animate, os, config, user, logo, designs, design, selectDesign, onPrimary, onSecondary, onImage }) => {
          const
              [ image, $image ] = useState(
                  config.images
                      ? (
                              os === 'ios' && config.images.ios
                                  ? config.images.ios
                                  : (
                                          os === 'android' && config.images.android
                                              ? config.images.android
                                              : config.images.default
                                      )
                          )
                      : null
              ),

              templates = {
                  'default':         OnboardingTemplateDefault,
                  'stick_static':    OnboardingTemplateStatic,
                  'stick_animation': OnboardingTemplateAnim,
                  'icons':           OnboardingTemplateIcons,
                  'design':          OnboardingTemplateDesign
              },

              CardTemplate = templates[ config.type.toLowerCase() ]
                  ? templates[ config.type.toLowerCase() ]
                  : templates.default

          useEffect(() => {
              $image(
                  config.images
                      ? (
                              os === 'ios' && config.images.ios
                                  ? config.images.ios
                                  : (
                                          os === 'android' && config.images.android
                                              ? config.images.android
                                              : config.images.default
                                      )
                          )
                      : null
              )
              //eslint-disable-next-line
    }, [config] )

          return (
              <div className={classNames( 'onboarding-popup', `onboarding-popup-type-${config.type}`, visible && 'onboarding-popup-visible', animate && 'onboarding-popup-animate' )}>
                  <CardTemplate
                      config = { config }
                      image = { image }
                      user = { user }
                      logo = { logo }
                      designs = { designs }
                      design = { design }
                      loading = { loading }

                      selectDesign = { selectDesign }
                      onFail = { () => $image( null ) }
                      onPrimary = { onPrimary }
                      onSecondary = { onSecondary }
                      onImage = { onImage }
                  />
              </div>
          )
      },

      Onboarding = ({ visible, config, user, logo, checks, designs, onAvatar, requestCorporate, setDesign, onFinish }) => {
          //console.log( 'on', config )

          const
              os = ui.getCurrentOs(),
              check = card => {
                  if ( !card.showif && !card.hideif ) { return true }

                  let
                      res = true

                  checks.os = os

                  if ( card.showif ) {
                      if ( card.compare === 'and' ) {
                          ( Object.keys( card.showif ).length < 1 ) && ( res = false )

                          Object.keys( card.showif ).forEach( key => {
                              res = res && comparator( key, card.showif[ key ], checks[ key ], true )
                          })
                      } else {
                          res = false

                          Object.keys( card.showif ).forEach( key => {
                              res = res || comparator( key, card.showif[ key ], checks[ key ], true )
                          })
                      }
                  } else {
                      if ( card.compare === 'or' ) {
                          res = false

                          Object.keys( card.hideif ).forEach( key => {
                              res = res || comparator( key, card.hideif[ key ], checks[ key ], false )
                          })
                      } else {
                          Object.keys( card.hideif ).forEach( key => {
                              res = res && comparator( key, card.hideif[ key ], checks[ key ], false )
                          })
                      }
                  }

                  return res
              },
              prepared = config.filter( item => check( item )).sort(( a, b ) => a.order - b.order ),

              timer = null,
              [ show, $show ] = useState( false ),
              [ hide, $hide ] = useState( false ),
              [ current, $current ] = useState( 0 ),
              [ design, $design ] = useState( appConfig.defaultDesign ),
              [ end, $end ] = useState( false ),
              [ loading, $loading ] = useState( false ),

              runOnboard = () => {
                  $show( true )
              },

              next = () => {
                  $hide( true )
                  setTimeout(() => {
                      $loading( false )
                      ;( current + 1 >= prepared.length ) && ( $show( false ))
                      $current( current + 1 )
                      setTimeout(() => {
                          $hide( false )
                      }, 100 )
                  }, 400 )
              },

              getAction = config => {
                  if ( !config || !config.action ) { return null }

                  switch ( config.action ) {
                      case '#next':
                          return next

                      case '#avatar':
                          return () => {
                              onAvatar(() => {
                                  ( config.event ) && ( adjust.track( config.event ))
                                  next()
                              })
                          }

                      case '#url':
                          return windowOpener( t( config.url, user ), () => {
                              ( config.event ) && ( adjust.track( config.event ))
                              next()
                          })

                      case '#wallet':
                          return windowOpener( `${appConfig.api.url}/pb/${user.card_id}`, () => {
                              ( config.event ) && ( adjust.track( config.event ))
                              next()
                          })

                      case '#request_corporate':
                          return () => {
                              requestCorporate( true )
                              ;( config.event ) && ( adjust.track( config.event ))
                              next()
                          }

                      case '#set_design':
                          return () => {
                              setDesign( design )
                              ;( config.event ) && ( adjust.track( config.event ))
                              next()
                          }

                      case '#designwallet':
                          return () => {
                              $loading( true )
                              setDesign( design, () => {
                                  ( config.event ) && ( adjust.track( config.event ))
                                  windowOpener( `${appConfig.api.url}/pb/${user.card_id}`, () => {
                                      next()
                                  })()
                              })
                          }

                      default:
                          return () => {
                              console.error( 'Unknown button action:', config.action )
                              next()
                          }
                  }
              }

          useEffect(() => {
              if ( !!visible && !show ) {
                  ( timer ) && ( clearTimeout( timer ))
                  setTimeout( runOnboard, 2000 )
              }
              //eslint-disable-next-line
        }, [visible] )

          useEffect(() => {
              if ( current >= prepared.length && !end ) {
                  $end( true )
                  ;( !!onFinish ) && ( onFinish())
              }
              //eslint-disable-next-line
        }, [current, prepared])

          useEffect(() => {
              if ( visible ) {
                  prepared.forEach( config => {
                      if ( config.images ) {
                          const
                              url = os === 'ios' && config.images.ios
                                  ? config.images.ios
                                  : (
                                          os === 'android' && config.images.android
                                              ? config.images.android
                                              : config.images.default
                                      ),
                              img = document.createElement( 'img' )

                          img.src = url
                          Object.assign(
                              img.style,
                              {
                                  position:      'absolute',
                                  left:          -9999,
                                  top:           -9999,
                                  pointerEvents: 'none',
                                  opacity:       0
                              }
                          )

                          document.body.appendChild( img )
                      }
                  })
              }
              //eslint-disable-next-line
        },[visible])

          if ( current >= prepared.length ) {
              return (
                  <div className='onboarding-backdrop'></div>
              )
          }

          return (
              <>
                  <div className={classNames( 'onboarding-backdrop', show && 'onboarding-backdrop-visible' )}></div>
                  <OnboardingCard
                      visible = { show && !hide && current < prepared.length }
                      animate = { show }
                      os = { os }
                      config = { prepared[ current ] }
                      user = { user }
                      logo = { logo }
                      designs = { designs }
                      design = { design }
                      loading = { loading }

                      selectDesign = { $design }
                      onPrimary = { getAction( prepared[ current ]?.primary_button ) }
                      onSecondary = { getAction( prepared[ current ]?.secondary_button ) }
                      onImage = { getAction( prepared[ current ]?.custom_button ) }
                  />
              </>
          )
      }

export default Onboarding
